import styled from 'styled-components'
import colours from './colours'

export default (element: any) =>
  styled(element)`
    color: ${colours.darkBlue};
    font-weight: bold;
    cursor: pointer;
    text-decoration: underline;
    :hover {
      color: ${colours.linkHover};
      text-decoration: underline;
    }
  `
